import React, { Component } from 'react';
import { Dropzone } from 'Components/forms/Dropzone';
import {
  ImageUploadStatusEnum,
  ImageUploadSizeEnum,
} from 'Common/Constants/Enumeration/ImageUploadStatusEnum';
import classNames from 'classnames';
import { Button, Form } from 'semantic-ui-react';
import { createToast, toastType } from 'Common/ToastHelper';
import { base64ToBlob } from 'Common/IEHelper';

class FieldOfficerSignature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageStatus: ImageUploadStatusEnum.Not_Uploaded,
      imageData: props.input.value,
    };
  }

  componentDidMount() {
    if (this.state.imageData) {
      this.setState({
        imageStatus: ImageUploadStatusEnum.Uploaded,
      });
    }
  }

  base64ImageToBlob = str => {
    const pos = str.indexOf(';base64,');
    const type = str.substring(5, pos);
    const b64 = str.substr(pos + 8);
    const imageContent = atob(b64);
    return base64ToBlob(imageContent, type);
  };

  onDrop = files => {
    if (files[0] !== undefined && files[0] !== 0) {
      let imgBase64String = `data:${files[0].type};base64,`;
      const reader = new window.FileReader();
      reader.readAsDataURL(files[0]);
      reader.onload = e => {
        imgBase64String += e.target.result.split(',')[1];
        this.props.input.onChange(imgBase64String);
      };
      this.setState({
        imageStatus: ImageUploadStatusEnum.Uploaded,
      });
    } else {
      createToast(
        toastType.error,
        'Error',
        `File could not be uploaded as it is not a jpeg/png/gif file or size is more than ${
          ImageUploadSizeEnum.MaxSize
        }`
      );
    }
  };

  removeSignature = () => {
    this.props.input.onChange('');
    this.setState({
      imageStatus: ImageUploadStatusEnum.Not_Uploaded,
    });
  };

  renderComponent = () => {
    return (
      <figure style={{ margin: 0 }}>
        <img
          src={this.props.input.value}
          alt="Signature"
          style={{ height: '15rem', width: '100%' }}
        />
        <figcaption className="control-info-form--dropzone--figcaption">
          <Button onClick={this.removeSignature}>Remove</Button>
        </figcaption>
      </figure>
    );
  };

  render() {
    const className = classNames(
      'file--dropzone control-info-form--dropzone',
      'file--dropzone-limited-width',
      {
        'file--dropzone-hidden':
          this.state.imageStatus !== ImageUploadStatusEnum.Not_Uploaded,
      }
    );

    return (
      <Form.Field>
        {this.state.imageStatus === ImageUploadStatusEnum.Uploaded &&
          this.renderComponent()}
        <Dropzone
          accept=".jpg,.jpeg,.gif,.png"
          activeClassName="file--dropzone--active"
          multiple={false}
          className={className}
          maxSize={ImageUploadSizeEnum.MaxSize}
          onDrop={this.onDrop}
        >
          <p>
            Drag and drop the signature image file here <br />
            <small>or click to select a file</small>.
          </p>
        </Dropzone>
      </Form.Field>
    );
  }
}

export { FieldOfficerSignature };



// WEBPACK FOOTER //
// ./src/pages/controlinformation/components/FieldOfficerSignature.js